<div class="column drawer-dialog">
	<div class="drawer-dialog-header display-flex-end">
		<h2 i18n="@@alertReportDialog-Title">Alert Report</h2>
		<button mat-icon-button>
			<mat-icon class="color-primary" (click)="onCloseDialog()" data-automation-id="alert-report-close-button"
				>close</mat-icon
			>
		</button>
	</div>

	<mat-dialog-content class="drawer-dialog-content">
		@if (isSentrilock) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@alertReportDialog-deviceOwner">Device Owners (optional)</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="device-owners-typeahead"
						[allDropdownOptions]="deviceOwnerOptions"
						[filterOnField]="'name'"
						[placeholderText]="this.deviceOwnerMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-nav-work'"
						[initiallySelectedItemIds]="deviceOwnerId"
						[initiallySelectedIdField]="'id'"
						[minCharactersForSearch]="3"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('deviceOwner', $event)"
						(searchInputChanged)="onSearchInput('deviceOwner', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
				<mat-divider></mat-divider>
			</div>
		}

		<h3 class="drawer-dialog-content-header" i18n="@@alertReportDialog-devices">Devices (optional)</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="devices-typeahead"
				[allDropdownOptions]="deviceOptions"
				[filterOnField]="'serialNumber'"
				[placeholderText]="this.deviceMultiSelectSearchPlaceholder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-nav-work'"
				[initiallySelectedItemIds]="deviceId"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('device', $event)"
				(searchInputChanged)="onSearchInput('device', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@alertReportDialog-alertTypes">Alert Types (optional)</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="alert-types-typeahead"
				[allDropdownOptions]="alertTypeOptions"
				[filterOnField]="'name'"
				[placeholderText]="this.alertTypeMultiSelectSearchPlaceholder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-nav-work'"
				[initiallySelectedItemIds]="alertTypeId"
				[initiallySelectedIdField]="'id'"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('alertType', $event)"
				(searchInputChanged)="onSearchInput('alertType', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		@if (isCareCompany) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientFirstName">Client First Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="first-name-typeahead"
						[allDropdownOptions]="firstNames"
						[filterOnField]="'firstName'"
						[placeholderText]="this.firstNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="firstName"
						[initiallySelectedIdField]="'firstName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('firstName', $event)"
						(searchInputChanged)="onSearchInput('firstName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientLastName">Client Last Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="last-name-typeahead"
						[allDropdownOptions]="lastNames"
						[filterOnField]="'lastName'"
						[placeholderText]="this.lastNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="lastName"
						[initiallySelectedIdField]="'lastName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('lastName', $event)"
						(searchInputChanged)="onSearchInput('lastName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientIdn">Client IDN</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="client-idn-typeahead"
						[allDropdownOptions]="clientIdns"
						[filterOnField]="'idn'"
						[placeholderText]="this.clientIdnMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="clientIdn"
						[initiallySelectedIdField]="'idn'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('clientIdn', $event)"
						(searchInputChanged)="onSearchInput('clientIdn', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>
		}

		<h3 class="drawer-dialog-content-header" i18n="@@alertReportDialog-propertyName">Property Name (optional)</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="property-name-typeahead"
				[allDropdownOptions]="propertyOptions"
				[filterOnField]="'name'"
				[placeholderText]="this.propertyNameMultiSelectSearchPlaceholder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-nav-work'"
				[initiallySelectedItemIds]="propertyId"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('property', $event)"
				(searchInputChanged)="onSearchInput('property', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@alertReportDialog-postalCodes">Postal Codes (optional)</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="postal-codes-typeahead"
				[allDropdownOptions]="postalCodeOptions"
				[filterOnField]="'name'"
				[placeholderText]="this.postalCodesMultiSelectSearchPlaceholder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-nav-work'"
				[initiallySelectedItemIds]="postalCodeId"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('postalCode', $event)"
				(searchInputChanged)="onSearchInput('postalCode', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@alertReportDialog-dateValid">Timeframe</h3>
		<div class="row" style="flex-wrap: nowrap">
			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@alertReportDialog-startDateValid">Start (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateValidStartPicker"
					placeholder="Start (optional)"
					i18n-placeholder="@@alertReportDialog-chooseStartDateValid"
					(dateChange)="onDateValidStartDateChanged($event)"
					[ngModel]="this.alertReportFilters.utcStartDate"
					data-automation-id="start-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateValidStartPicker"
					data-automation-id="start-date-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateValidStartPicker data-automation-id="start-date-datepicker"></mat-datepicker>
			</mat-form-field>

			<div style="display: flex; flex-direction: column; justify-content: center; padding: 0 24px">To</div>

			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@alertReportDialog-endDateValid">End (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateValidEndPicker"
					placeholder="End (optional)"
					i18n-placeholder="@@alertReportDialog-ChooseEndDateValid"
					(dateChange)="onDateValidEndDateChanged($event)"
					[ngModel]="this.alertReportFilters.utcEndDate"
					data-automation-id="end-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateValidEndPicker"
					data-automation-id="end-date-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateValidEndPicker data-automation-id="end-date-datepicker"></mat-datepicker>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions class="margin-bottom-none">
		<div class="row content-flex-end">
			<div class="bottom-border"></div>
			<button
				mat-button
				class="secondary-button"
				i18n="@@alertReportDialog-closeWindow"
				(click)="onCloseDialog()"
				data-automation-id="alert-report-cancel-button"
			>
				Cancel
			</button>
			<button
				mat-button
				class="primary-button"
				style="margin-right: 24px"
				(click)="onGenerateReport()"
				data-automation-id="alert-report-generate-report-button"
			>
				{{ this.primaryButtonText }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
